import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

import { ViewWLSubscriptionsTiers } from "../../../Common/models/subscriptions";
import { Giveaway } from "../../../Common/models/giveaways";
import { WLConfig } from "../../../Common/models/config";
import { createWithEqualityFn } from "zustand/traditional";

interface UserCancelSubscriptionState {
  hasCancelled: boolean;
  setHasCancelled: () => void;

  ongoingGiveaway: null | Giveaway;
  setOngoingGiveaway: (state: null | Giveaway) => void;

  majorAndSuperGiveawayList: null | Giveaway[];
  setMajorAndSuperGiveawayList: (state: Giveaway[]) => void;

  subscriptionList: null | ViewWLSubscriptionsTiers[];
  setSubscriptionList: (state: ViewWLSubscriptionsTiers[]) => void;

  powerUpList: null | ViewWLSubscriptionsTiers[];
  setPowerUpList: (state: ViewWLSubscriptionsTiers[]) => void;

  cancelView: boolean;
  setCancelView: (state: boolean) => void;
  wlConfig: null | WLConfig;
  setWlConfig: (state: WLConfig) => void;
  resetCancelSubsStore: () => Promise<void>;
}

export const useUserCancelSubscriptionStore = createWithEqualityFn<
  UserCancelSubscriptionState,
  [["zustand/persist", UserCancelSubscriptionState]]
>(
  persist(
    (set, get) => ({
      hasCancelled: false,
      setHasCancelled: () => set({ hasCancelled: true }),

      ongoingGiveaway: null,
      setOngoingGiveaway: (ongoingGiveaway) => set({ ongoingGiveaway }),

      majorAndSuperGiveawayList: null,
      setMajorAndSuperGiveawayList: (giveAwayList) =>
        set({ majorAndSuperGiveawayList: giveAwayList }),

      subscriptionList: null,
      setSubscriptionList: (subscriptionList) => set({ subscriptionList }),
      powerUpList: null,
      setPowerUpList: (powerUpList) => set({ powerUpList }),

      cancelView: false,
      setCancelView: (cancelView) => set({ cancelView }),
      wlConfig: null,
      setWlConfig: (config) => set({ wlConfig: config }),
      resetCancelSubsStore: async () => {
        return set(() => ({
          hasCancelled: false,
          cancelView: false,
          subscriptionList: null,
          ongoingGiveaway: null,
          majorAndSuperGiveawayList: null,
        }));
      },
    }),
    {
      name: "web-cancel-subscription", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    }
  )
);
